export default __webpack_public_path__ + "src/assets/membership-illustration.53959c60f981868f5ee365c5af54b506.svg";